module.exports = __webpack_public_path__ + "static/media/AGSCoCareHELP_Delirium Script_1638711762929.16d7b13f.docx";